const Profile = () => import(/*webpackChunkName: 'profile'*/ '@/views/profile/Profile');
const ProfileOverview = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/overview/Profile');
const ProfileMorningMonitoring = () =>
    import(/*webpackChunkName: 'profile-reports'*/ '@/components/profile/morning-monitoring/MorningMonitoring');
const ProfileNotes = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/notes/ProfileNotes');
const ProfileDrv = () => import(/*webpackChunkName: 'profile-drv'*/ '@/components/profile/drv/ProfileDrv');
const ProfileSettings = () => import(/*webpackChunkName: 'profile'*/ '@/components/profile/settings/ProfileSettings');

import { LUDUM_USER_STATUSES } from '@/constants';
const { ATHLETE_REJECTED, LEFT, REJECTED } = LUDUM_USER_STATUSES;
import {
    ROUTES_PROFILE,
    ROUTES_PROFILE_DRV,
    ROUTES_PROFILE_MORNING_MONITORING,
    ROUTES_PROFILE_NOTES,
    ROUTES_PROFILE_OVERVIEW,
    ROUTES_PROFILE_SETTINGS
} from '@/constants/routes';
import { PROFILE_REPORT_ROUTES } from './profile-reports';
import { isAthlete as userIsAthlete } from '@/helpers/rolesHelper';
import store from '@/store';
import { guardRoute } from '@/router';
import get from 'get-object-path';

export default {
    path: '/profile',
    name: ROUTES_PROFILE,
    component: Profile,
    redirect: { name: ROUTES_PROFILE_OVERVIEW },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/profile/:id',
            name: ROUTES_PROFILE_OVERVIEW,
            beforeEnter: guardRouteProfile,
            component: ProfileOverview,
            props: true
        },
        {
            path: '/profile/morning-monitoring/:id',
            name: ROUTES_PROFILE_MORNING_MONITORING,
            beforeEnter: guardRouteMorningMonitoring,
            component: ProfileMorningMonitoring,
            props: true
        },
        {
            path: '/profile/notes/:id',
            name: ROUTES_PROFILE_NOTES,
            beforeEnter: guardRouteProfile,
            component: ProfileNotes,
            props: false
        },
        {
            path: '/profile/drv/:id',
            name: ROUTES_PROFILE_DRV,
            beforeEnter: guardRouteDrvProfile,
            component: ProfileDrv,
            props: true
        },
        {
            path: '/profile/settings/:id',
            name: ROUTES_PROFILE_SETTINGS,
            beforeEnter: guardRouteProfile,
            component: ProfileSettings,
            props: true
        },
        ...PROFILE_REPORT_ROUTES
    ]
};

async function guardRouteProfile(to, from, next) {
    const profileId = Number(to.params.id);
    const profile = await store.dispatch('profileGeneral/getAthleteDetails', profileId);

    const isActive = ![ATHLETE_REJECTED, LEFT, REJECTED].includes(get(profile || {}, 'status.data.id'));
    !isActive && next({ path: '404' });

    const isAthlete = userIsAthlete(get(profile || {}, 'roles.data[0].id'));
    const ownProfile = store.getters['clubHelper/me'].id === profileId;
    const isOnProfileNotes = to.name === ROUTES_PROFILE_NOTES;
    const authorized = isOnProfileNotes
        ? ownProfile
        : ownProfile || (isAthlete && store.getters['userPermissions/canViewAthleteProfile']);
    guardRoute(next, !authorized);
}

async function guardRouteMorningMonitoring(to, from, next) {
    const profileId = Number(to.params.id);
    const profile = await store.dispatch('profileGeneral/getAthleteDetails', profileId);
    const isAthlete = userIsAthlete(get(profile || {}, 'roles.data[0].id'));
    const ownProfile = store.getters['clubHelper/me'].id === profileId;
    const authorized = ownProfile ? isAthlete : isAthlete && store.getters['userPermissions/canViewAthleteProfile'];
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureMorningMonitoring'];
    guardRoute(next, !authorized, notInFeatureSet);
}

async function guardRouteDrvProfile(to, from, next) {
    const profileId = Number(to.params.id);
    const profile = await store.dispatch('profileGeneral/getAthleteDetails', profileId);
    const isAthlete = userIsAthlete(get(profile || {}, 'roles.data[0].id'));
    const ownProfile = store.getters['clubHelper/me'].id === profileId;
    const authorized = ownProfile
        ? isAthlete
        : isAthlete &&
          (store.getters['userPermissions/canViewDrvProfileTab'] ||
              store.getters['userPermissions/canViewDrvPersonalDetails']);
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureDrv'];
    guardRoute(next, !authorized, notInFeatureSet);
}
